import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { EditorContext } from '@atlaskit/editor-common/UNSAFE_do_not_use_editor_context';
import { fg } from '@atlaskit/platform-feature-flags';
import EditorActions from '../../actions';
export var useEditorContext = function useEditorContext() {
  return React.useContext(EditorContext);
};

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, react/prefer-stateless-function
export var LegacyEditorContext = /*#__PURE__*/function (_React$Component) {
  function LegacyEditorContext(props) {
    _classCallCheck(this, LegacyEditorContext);
    return _callSuper(this, LegacyEditorContext, [props]);
  }
  _inherits(LegacyEditorContext, _React$Component);
  return _createClass(LegacyEditorContext, [{
    key: "render",
    value: function render() {
      if (fg('platform_editor_react18_phase2_v2')) {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/React.createElement(LegacyEditorContextNew, this.props, this.props.children);
      }

      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
      return /*#__PURE__*/React.createElement(LegacyEditorContextOld, this.props, this.props.children);
    }
  }]);
}(React.Component);
function LegacyEditorContextNew(_ref) {
  var children = _ref.children,
    editorActions = _ref.editorActions;
  return /*#__PURE__*/React.createElement(EditorContext.Provider, {
    value: {
      editorActions: editorActions !== null && editorActions !== void 0 ? editorActions : new EditorActions()
    }
  }, children);
}

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var LegacyEditorContextOld = /*#__PURE__*/function (_React$Component2) {
  function LegacyEditorContextOld(props) {
    var _this;
    _classCallCheck(this, LegacyEditorContextOld);
    _this = _callSuper(this, LegacyEditorContextOld, [props]);
    _this.editorActions = props.editorActions || new EditorActions();
    return _this;
  }
  _inherits(LegacyEditorContextOld, _React$Component2);
  return _createClass(LegacyEditorContextOld, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        editorActions: this.editorActions
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(EditorContext.Provider, {
        value: this.getChildContext()
      }, this.props.children);
    }
  }]);
}(React.Component);
_defineProperty(LegacyEditorContextOld, "childContextTypes", {
  editorActions: PropTypes.object
});
export { LegacyEditorContextOld as default };